var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { ACTING_ENTITY_HEADER } from '@app/configs/api/index';
import ConfigProvider from '@app/service/configProvider/ConfigProvider';
const createAxiosClient = (baseURL, tokenService, audience, scope) => {
    const axiosInstance = axios.create({
        baseURL,
    });
    axiosInstance.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
        const token = yield tokenService.getToken(scope, audience);
        config.headers.Authorization = `Bearer ${token}`;
        const administeredUserId = ConfigProvider.getAdministeredUserId();
        const userId = ConfigProvider.getUserConfig().getUserId();
        if (administeredUserId && administeredUserId !== userId) {
            config.headers[ACTING_ENTITY_HEADER] = administeredUserId;
        }
        return config;
    }));
    axiosInstance.interceptors.response.use((response) => response, (error) => __awaiter(void 0, void 0, void 0, function* () {
        const originalRequest = error.config;
        if ((error === null || error === void 0 ? void 0 : error.response) && error.response.status === 401 && !originalRequest.retry) {
            originalRequest.retry = true;
            tokenService.clearToken();
            const token = yield tokenService.refreshToken(scope, audience);
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return axiosInstance(originalRequest);
        }
        return Promise.reject(error);
    }));
    return axiosInstance;
};
export default createAxiosClient;
